import { create } from 'zustand';
import type { CategoryType } from '@t/productOffering.types';

interface ProductOffersStore {
  activeCategoryFilters: Record<CategoryType, boolean>;
  setActiveCategoryFilters: (
    updater: Record<CategoryType, boolean> | ((prev: Record<CategoryType, boolean>) => Record<CategoryType, boolean>)
  ) => void;
  footerCheckoutError: boolean;
  setFooterCheckoutError: (value: boolean) => void;
}

export const useProductOffersStore = create<ProductOffersStore>((set) => ({
  activeCategoryFilters: {
    Bundle: true,
    Internet: true,
    Video: true,
    Phone: true,
    EV: true,
  },
  setActiveCategoryFilters: (updater) => {
    set((state) => ({
      activeCategoryFilters: typeof updater === 'function' ? updater(state.activeCategoryFilters) : updater,
    }));
  },
  footerCheckoutError: false,
  setFooterCheckoutError: (value) => set({ footerCheckoutError: value }),
}));
